import React, { useState, useRef } from "react";
import Header01 from "../components/Headers/Header01";
import { alphabets, Animals } from "../Data";
import ReactPlayer from "react-player";
import PlayOverlay from "../components/PlayOverlay";
import AnimalWithName from "../components/AnimalWithName";
import { motion } from "framer-motion";

type Props = {};

const IsFor = (props: Props) => {
  const [CurrentLetter] = useState<number>(0);
  const [ClickToPlay, setClickToPlay] = useState<boolean>(true);

  const [Audio, setAudio] = useState<null | string>(null);
  const [Playing, setPlaying] = useState<boolean>(false);
  const playerRef = useRef<ReactPlayer | null>(null);

  const ParrotMotion = {
    start: {
      x: 1000,
      opacity: 0,
    },
    show: {
      transition: { delay: 1.5 },
      opacity: 1,
      x: 0,
    },
  };

  const ParrotChatMotion = {
    start: {
      x: 1000,
      opacity: 0,
    },
    show: {
      transition: { delay: 2 },
      opacity: 1,
      x: 0,
    },
  };

  return (
    <div className={`w-full h-screen flex flex-col justify-between z-0`}>
      {ClickToPlay ? <PlayOverlay setClickToPlay={setClickToPlay} /> : null}

      {/* <div className="hidden">
        <BgAudioPlayer ClickToPlay={ClickToPlay} />
      </div> */}

      {/* { Audio && Playing ?
        <div className="hidden">
          <AudioPlayer audio={Audio} playing={Playing}/>
        </div>
        : null
      } */}

      {Audio && Playing ? (
        <div className="hidden">
          <ReactPlayer
            url={Audio}
            config={{
              file: { forceAudio: true },
            }}
            onPlay={() => {
              console.log("Audio Playing");
            }}
            onEnded={() => {
              setPlaying(false);
            }}
            loop={false}
            controls
            playing={Playing}
            ref={playerRef}
            // volume={0.7}
          />
        </div>
      ) : null}

      <Header01 letter={alphabets[CurrentLetter]} />

      {ClickToPlay ? (
        <PlayOverlay setClickToPlay={setClickToPlay} />
      ) : (
        <>
          {Animals ? (
            <div
              className={`flex flex-row justify-between relative px-[3%] z-0`}
            >
              <div className="flex flex-row flex-wrap justify-center gap-4 my-[10%] w-[60%]">
                {Animals.slice(0, 3).map((data, index) => (
                  <motion.div
                    // variants={animateTransition}
                    // initial="start"
                    // animate="show"
                    initial={{ x: -1000, opacity: 0 }}
                    whileTap={{
                      rotate: [0, -10, 10, -10, 10, 0],
                      transition: { duration: 0.3 },
                    }}
                    animate={{ transition: { delay: 1.1 + parseFloat(`0.${index + 1}`) }, opacity:1 , x: 0 }}
                    key={index}
                    onClick={() => {
                      if (Playing === false) {
                        setAudio(data.audio);
                        setPlaying(true);
                      } else {
                        setPlaying(false);
                        setAudio(null);
                      }
                    }}
                    className={`cursor-pointer`}
                  >
                    <AnimalWithName
                      Animal={data.name}
                      Image={data.image}
                      key={index}
                    />
                  </motion.div>
                ))}
              </div>
              <div className="flex flex-col gap-2 w-[35%] justify-center my-[2%]">
                {/* Parrot Bubble chat */}
                <motion.div
                  variants={ParrotChatMotion}
                  initial="start"
                  animate="show"
                  whileTap={{
                    rotate: [0, -10, 10, -10, 10, 0],
                    transition: { duration: 0.3 },
                  }}
                  className={`z-10 w-60 h-60 self-start cursor-pointer`}
                  onClick={() => {
                    if (Playing === false) {
                      setAudio("/music/aIsFor.mp3");
                      setPlaying(true);
                    } else {
                      setPlaying(false);
                      setAudio(null);
                    }
                  }}
                >
                  <div className="relative">
                    <img
                      src="/Others/SpeechBubble.png"
                      alt="Wilf"
                      className={``}
                    />
                    <div className="absolute inset-0 mb-16 flex flex-col justify-center items-center z-15">
                      <h4
                        className={`font-extrabold lg:text-8xl text-6xl word-primary`}
                      >
                        '{alphabets[CurrentLetter]}'
                      </h4>
                      <p className={`font-extrabold lg:text-3xl text-2xl`}>
                        is for...
                      </p>
                    </div>
                  </div>
                </motion.div>
                {/* Parrot Image */}
                <motion.div 
                  variants={ParrotMotion}
                  initial="start"
                  animate="show"
                  whileHover={{ 
                    
                  }}
                  className={`z-10 w-[80%] self-end`}
                >
                  <img src="/Animals/ParrotInclined.png" alt="inclined bird" />
                </motion.div>
              </div>
            </div>
          ) : (
            <p className="text-xl text-center font-extrabold">Loading...</p>
          )}
        </>
      )}
      {/* Next Previous buttons */}
      {/* <NextPreviousBTN setCurrentLetter={setCurrentLetter} CurrentLetter={CurrentLetter}/> */}
    </div>
  );
};

export default IsFor;
